import * as THREE from 'three'
import SceneSubject from './SceneSubject'
import GeneralLights from './GeneralLights'

export default (canvas, data, visitordata) => {
  const clock = new THREE.Clock()
  const origin = new THREE.Vector3(0, 0, 0)

  const screenDimensions = {
    width: canvas.width,
    height: canvas.height,
  }

  let mousePosition = { x: 0, y: 0 }
  let mousePositionOnDown = { x: 0, y: 0 }
  let target = { x: (Math.PI * 3) / 2, y: Math.PI / 6.0 }
  let targetOnDown = { x: 0, y: 0 }

  let curZoomSpeed = 0
  let rotation = { x: 0, y: 0 }
  let distance = 100000
  let distanceTarget = 100000
  const PI_HALF = Math.PI / 2

  const scene = buildScene()
  const renderer = buildRender(screenDimensions)
  const camera = buildCamera(screenDimensions)
  const sceneSubjects = createSceneSubjects(scene)

  function buildScene() {
    const scene = new THREE.Scene()
    return scene
  }

  function buildRender({ width, height }) {
    const renderer = new THREE.WebGLRenderer({
      canvas: canvas,
      antialias: true,
      alpha: true,
    })
    const DPR = window.devicePixelRatio ? window.devicePixelRatio : 1
    renderer.setPixelRatio(DPR)
    renderer.setSize(width, height)

    renderer.gammaInput = true
    renderer.gammaOutput = true

    return renderer
  }

  function zoom(delta) {
    distanceTarget -= delta
    distanceTarget = distanceTarget > 1000 ? 1000 : distanceTarget
    distanceTarget = distanceTarget < 350 ? 350 : distanceTarget
  }

  function buildCamera({ width, height }) {
    const aspectRatio = width / height
    const fieldOfView = 30
    const nearPlane = 1
    const farPlane = 10000
    const camera = new THREE.PerspectiveCamera(
      fieldOfView,
      aspectRatio,
      nearPlane,
      farPlane
    )

    camera.position.z = distance

    return camera
  }

  function createSceneSubjects(scene) {
    const sceneSubjects = [
      new GeneralLights(scene),
      new SceneSubject(scene, data, visitordata),
    ]

    return sceneSubjects
  }

  function update() {
    const elapsedTime = clock.getElapsedTime()

    zoom(curZoomSpeed)
    rotation.x += (target.x - rotation.x) * 0.1
    rotation.y += (target.y - rotation.y) * 0.1
    distance += (distanceTarget - distance) * 0.3

    camera.position.x = distance * Math.sin(rotation.x) * Math.cos(rotation.y)
    camera.position.y = distance * Math.sin(rotation.y)
    camera.position.z = distance * Math.cos(rotation.x) * Math.cos(rotation.y)

    for (let i = 0; i < sceneSubjects.length; i++)
      sceneSubjects[i].update(elapsedTime)

    updateCameraPositionRelativeToMouse()

    renderer.render(scene, camera)
  }

  function updateCameraPositionRelativeToMouse() {
    camera.position.x += (mousePosition.x * 0.01 - camera.position.x) * 0.01
    camera.position.y += (-(mousePosition.y * 0.01) - camera.position.y) * 0.01
    camera.lookAt(origin)
  }

  function onWindowResize() {
    const { width, height } = canvas

    screenDimensions.width = width
    screenDimensions.height = height

    camera.aspect = width / height
    camera.updateProjectionMatrix()

    renderer.setSize(width, height)
  }

  function onMouseDown(x, y) {
    mousePositionOnDown.x = -x
    mousePositionOnDown.y = y
    targetOnDown.x = target.x
    targetOnDown.y = target.y
  }

  function onMouseMove(x, y) {
    mousePosition.x = -x
    mousePosition.y = y

    var zoomDamp = distance / 1000

    target.x =
      targetOnDown.x +
      (mousePosition.x - mousePositionOnDown.x) * 0.005 * zoomDamp
    target.y =
      targetOnDown.y +
      (mousePosition.y - mousePositionOnDown.y) * 0.005 * zoomDamp

    target.y = target.y > PI_HALF ? PI_HALF : target.y
    target.y = target.y < -PI_HALF ? -PI_HALF : target.y
  }

  return {
    update,
    onWindowResize,
    onMouseMove,
    onMouseDown,
  }
}



// WEBPACK FOOTER //
// ./src/components/threejs/SceneManager.js